/**
 * Parses a shorthand amount string into a number.
 *
 * Example:
 * - "1k" -> 1000
 * - "1.5m" -> 1500000
 * - "2.5b" -> 2500000000
 *
 * @param value - The shorthand amount string to parse.
 * @returns The parsed number.
 */
export const parseShorthandAmount = (value: string): number => {
  const cleanValue = value.toLowerCase().replace(/[$]/g, "");

  if (cleanValue.endsWith("k")) {
    return parseFloat(cleanValue) * 1000;
  }
  if (cleanValue.endsWith("m")) {
    return parseFloat(cleanValue) * 1000000;
  }
  if (cleanValue.endsWith("b")) {
    return parseFloat(cleanValue) * 1000000000;
  }
  return parseFloat(cleanValue);
};
